export default __webpack_public_path__ + "static/media/AdobeStock_247180439.0853126d.jpg";